/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Check_IncompleteInputs */

const cs_portals_check_incomplete = /** @type {(inputs: Portals_Check_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzerát není kompletní pro export`)
};

const en_portals_check_incomplete = /** @type {(inputs: Portals_Check_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing is incomplete for export`)
};

/**
* | output |
* | --- |
* | "Listing is incomplete for export" |
*
* @param {Portals_Check_IncompleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_incomplete = /** @type {((inputs?: Portals_Check_IncompleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_IncompleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_incomplete(inputs)
	return cs_portals_check_incomplete(inputs)
});